import { RatingStarsOnlyStars } from "@/components/RatingStars";
import {
  createProductReview,
  createProductReviewV2,
  uploadReviewImage,
} from "@/requests/product";
import {
  setGlobalPopupElement,
  setIsUserReviewed,
} from "@/store/features/globalSlice";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { toastMe } from "@/utils";
import { getS3ImageUrl } from "@/utils/routes";
import { Rating, Textarea } from "@mantine/core";
import Image from "next/image";
import { useState } from "react";

interface Props {
  from?: string;
  product: OrderProduct | ProductDetails;
}

const ReviewForm = ({ product, from = "order" }: Props) => {
  const [comment, setComment] = useState("");
  const [images, setImages] = useState();
  const [imagePreviews, setImagePreviews] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const [rating, setRating] = useState(5);
  const user = useAppSelector((state) => state.auth.user);
  const [name, setName] = useState<string>("");
  // const [priceRating, setPriceRating] = useState(5);
  // const [serviceRating, setServiceRating] = useState(5);
  // const [valueRating, setValueRating] = useState(5);
  // const [qualityRating, setQualityRating] = useState(5);

  const handleSubmit = () => {
    if (!rating) {
      toastMe("Please give a rating!", "warning");
      return;
    }

    if (!!!user?.firstName && name === "") {
      toastMe("Please enter your name!", "warning");
      return;
    }

    // const rating =
    //   (priceRating + serviceRating + valueRating + qualityRating) / 4;

    setLoading(true);

    if (from === "order") {
      const orderProduct = product as OrderProduct;

      const reviewData: any = {};
      reviewData.rating = rating;
      reviewData.order_id = orderProduct.orderId;
      reviewData.order_product_id = orderProduct.id;
      reviewData.comment = comment;
      reviewData.first_name = name;

      createProductReview(reviewData)
        .then((response) => {
          dispatch(setIsUserReviewed({ [orderProduct.id]: true }));

          toastMe("Successfully published your review", "success");
        })
        .catch((error) => {
          toastMe("Something went wrong!", "error");
        })
        .finally(() => {
          setLoading(false);
          dispatch(setGlobalPopupElement(null));
        });
    } else {
      const reviewProduct = product as ProductDetails;

      const reviewData: any = {};
      reviewData.rating = rating;
      reviewData.product_id = reviewProduct.id;
      reviewData.comment = comment;
      reviewData.first_name = name;

      createProductReviewV2(reviewData)
        .then((response) => {
          dispatch(setIsUserReviewed({ [reviewProduct.id]: true }));

          toastMe("Successfully published your review", "success");
        })
        .catch((error) => {
          toastMe("Something went wrong!", "error");
        })
        .finally(() => {
          setLoading(false);
          dispatch(setGlobalPopupElement(null));
        });
    }
  };

  return (
    <div className="bg-white p-8 rounded-md md:min-w-[30vw] md:max-w-[80vw] max-h-[80vh] overflow-y-scroll scrollbar-ui">
      <div className="overflow-hidden">
        <div className="mb-4 flex gap-2 items-start">
          <figure>
            <Image
              src={
                from === "order"
                  ? getS3ImageUrl(product.thumbnail)
                  : getS3ImageUrl(product.thumbnail.split(",")[0])
              }
              height={100}
              width={100}
              unoptimized={true}
              className="border "
              alt={product.name || "product image"}
            />
          </figure>
          <div>
            <p className="font-semibold">Share Your Feedback</p>
            <p>{product.name}</p>
          </div>
        </div>

        <div>
          <div>
            {!!!user?.firstName && (
              <div className="flex flex-col">
                <label htmlFor="name" className="text-lg font-semibold">
                  Name
                </label>
                <input
                  className="w-full bg-backgournd-card rounded-[5px] py-3 px-4 text-sm text-gray3"
                  id="name"
                  type="text"
                  placeholder="Your Name"
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
            )}

            <p className="text-lg font-semibold mt-2">
              Select Your Product Rating<span className="text-red-600">*</span>
            </p>

            <div className="my-2 flex flex-col md:flex-row gap-4 justify-between">
              <div className="space-y-4">
                <div className="flex items-center gap-2">
                  <p className="font-medium text-sm">Bad</p>
                  <Rating size="lg" value={rating} onChange={setRating} />
                  <p className="font-medium text-sm">Good</p>
                </div>
                {/* <div>
                  <p className="font-medium">Service</p>
                  <Rating
                    size="lg"
                    value={serviceRating}
                    onChange={setServiceRating}
                  />
                </div> */}
              </div>

              {/* <div className="space-y-4">
                <div>
                  <p className="font-medium">Value</p>
                  <Rating
                    size="lg"
                    value={valueRating}
                    onChange={setValueRating}
                  />
                </div>
                <div>
                  <p className="font-medium">Quality</p>
                  <Rating
                    size="lg"
                    value={qualityRating}
                    onChange={setQualityRating}
                  />
                </div>
              </div> */}
            </div>
          </div>

          <div>
            <label htmlFor="images" className="text-lg font-semibold">
              Share Your Thoughts
            </label>{" "}
            <br />
            <textarea
              name="review"
              id="review"
              cols={10}
              rows={5}
              // className="border rounded w-full p-2 my-2"
              className="w-full bg-backgournd-card rounded-[5px] py-3 px-4 text-sm text-gray3"
              onChange={(e) => setComment(e.target.value)}
              required
            ></textarea>
          </div>

          <button
            className="bg-primary text-white px-4 py-2 rounded-md font-medium disabled:opacity-40 flex items-center gap-2"
            onClick={handleSubmit}
            disabled={loading}
          >
            SUBMIT
            {loading && (
              <span className="block border-gray-300 h-5 w-5 animate-spin rounded-full border-2 border-t-blue-600" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReviewForm;

// const handleImageChange = (e: any) => {
//   const images = e.target.files;
//   const imgPreviews: any[] = [];

//   for (let i = 0; i < images.length; i++) {
//     imgPreviews.push(URL.createObjectURL(images[i]));
//   }

//   setImages(images);
//   setImagePreviews(imgPreviews);
// };

// const handleSubmit = () => {
//   if (!rating) {
//     toastMe("Please give a rating!", "warning");
//     return;
//   }
//   setLoading(true);

//   const formData = new FormData();

//   if (images) {
//     [...images].forEach((img) => {
//
//       formData.append("product_image", img);
//     });

//     uploadReviewImage(formData).then((response) => {
//       if (response.success === true) {
//         // post review
//         const reviewData: any = {};
//         reviewData.rating = rating;
//         reviewData.order_id = product.orderId;
//         reviewData.order_product_id = product.id;
//         reviewData.product_image = response.data
//           .map((item) => item.fileName)
//           .join(",");
//         reviewData.comment = comment;

//         createProductReview(reviewData)
//           .then((response) => {
//             dispatch(setIsUserReviewed({ [product.id]: true }));

//             toastMe("Successfully published your review", "success");
//           })
//           .catch((error) => {
//             toastMe("Something went wrong!", "error");
//           })
//           .finally(() => {
//             setLoading(false);
//             dispatch(setGlobalPopupElement(null));
//           });
//       }
//     });
//   } else {
//     // review without images
//     const reviewData: any = {};
//     reviewData.rating = rating;
//     reviewData.order_id = product.orderId;
//     reviewData.order_product_id = product.id;
//     reviewData.comment = comment;

//     createProductReview(reviewData)
//       .then((response) => {
//         dispatch(setIsUserReviewed({ [product.id]: true }));

//         toastMe("Successfully published your review", "success");
//       })
//       .catch((error) => {
//         toastMe("Something went wrong!", "error");
//       })
//       .finally(() => {
//         setLoading(false);
//         dispatch(setGlobalPopupElement(null));
//       });
//   }
// };

{
  /* <div>
          <label htmlFor="images" className="text-lg font-semibold">
            Add Product Images
          </label>{" "}
          {imagePreviews.length > 0 && (
            <div className="flex gap-2 my-2">
              {imagePreviews.map((img: any, index: any) => {
                return (
                  <img
                    key={index}
                    src={img}
                    className="w-16 h-16 object-contain border"
                  />
                );
              })}
            </div>
          )}
          {!imagePreviews.length && <br />}
          <input
            type="file"
            name="files"
            id="files"
            accept="image/*, video/mp4"
            className="my-2"
            onChange={handleImageChange}
            multiple
          />
        </div> */
}
